import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const Organizace = {
	name: NAME,
	router,
	apiProvider,
};
